/*jshint esversion: 6 */
import React from 'react';
import { connect } from 'react-redux';
import { MedicActions } from 'app/redux/actions.js';

function mapStateToProps(state) {
    return ({
        medic: state.medic
    });
}

function mapDispatchToProps(dispatch) {
    return {
        startInputMedic: (id) => dispatch(MedicActions.startInputMedic(id)),
        fetchInputMedicStatus: (id, token) => dispatch(MedicActions.fetchInputMedicStatus(id, token)),
        fetchInputMedicList: (id) => dispatch(MedicActions.fetchInputMedicList(id)),
        startFeedMedic: (url, sessionGuid) => dispatch(MedicActions.startFeedMedic(url, sessionGuid)),
        fetchFeedMedicStatus: (token) => dispatch(MedicActions.fetchFeedMedicStatus(token)),
        fetchFeedMedicShare: (token) => dispatch(MedicActions.fetchFeedMedicShare(token)),
        resetMedic: () => dispatch(MedicActions.resetMedic())
    };
}

export default function MedicProvider(Component) {
    class MedicProvider extends React.Component {
        render() {
            return (<Component {...this.props}/>);
        }
    }
    MedicProvider.displayName = "MedicProvider";
    return connect(mapStateToProps, mapDispatchToProps)(MedicProvider);
}
